import axios from "axios";
import { errorMessage, tokenExpired, errorAlert } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    specialServiceInfo: null
  },
  getters: {
    showSpecialServiceInfo(state) {
      return state.specialServiceInfo;
    }
  },
  mutations: {
    setSpecialServiceInfo(state, specialServiceInfo) {
      state.specialServiceInfo = specialServiceInfo;
    }
  },
  actions: {
    async getPredictionSpecialService({ commit }, info) {
      let method = "4T_ZIP";
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/special-service?method=${method}&miles=${info.miles}&origin_state=${info.origin_state}&origin_zip_code=${info.origin_zip_code}&destination_state=${info.destination_state}&destination_zip_code=${info.destination_zip_code}`,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setSpecialServiceInfo", response?.data);
          return response;
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.status == 422) {
          errorAlert(
            "Error",
            "Please check the field information on all trips."
          );
        } else if (err.response.status != 200) {
          if (
            err.response?.data?.detail[0].msg ||
            err?.response?.data?.detail
          ) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg || err?.response?.data?.detail
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async calculateQuoteSpecialService({ commit }, info) {
      const body = { ...info.body };
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/special-service?haul_id=${info.haul_id}`,
          body,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setSpecialServiceInfo", response?.data);
          return response;
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (
            err.response?.data?.detail[0].msg ||
            err?.response?.data?.detail
          ) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg || err?.response?.data?.detail
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async getSpecialServiceData({ commit }, info) {
      const params = {};
      params.haul_id = info.haul_id;
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/special-service/quote`,
          {
            params: params,
            ...api.getToken()
          }
        );
        if (response.status == 200) {
          if (
            response?.data?.cost?.cargo !== null &&
            response?.data?.price?.cargo !== null
          ) {
            commit("setSpecialServiceInfo", response?.data);
          }
          return response;
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    }
  }
};
